import { queryOptions, useQuery } from '@tanstack/react-query';

import { STALE_TIMES } from '#lib/queryConstants';

import { getApiKeys } from '../../api/apiKeysService';

import { apiKeysKeys } from './keys';

export const apiKeysOptions = () =>
	queryOptions({
		queryKey: apiKeysKeys.all,
		queryFn: async () => {
			const response = await getApiKeys();
			return response.apiKeys ?? [];
		},
		staleTime: STALE_TIMES.STANDARD,
		retry: 2,
	});

export function useApiKeys() {
	return useQuery(apiKeysOptions());
}
